<div class="editstate">
    <button
        class="badge"
        [ngClass]="getStatusColor(entity().approval)"
        [matMenuTriggerFor]="statusMenu"
        (click)="badgeClicked.emit(entity().id)"
    >
        {{ getTranslationKey(entity().approval) | transloco }}
    </button>
</div>

<mat-menu
    #statusMenu="matMenu"
    xPosition="before"
    panelClass="state-badge-menu"
>
    @for (status of availableStatuses; track status) {
    <button
        mat-menu-item
        (click)="changeState(status)"
        [disabled]="entity().approval === status"
    >
        <span
            class="status-dot"
            [ngClass]="getStatusColor(status)"
        ></span>
        {{ getTranslationKey(status) | transloco }}
    </button>
    }
</mat-menu>